
    import './styles.scoped.css';
    export default {
  "appbar": "awsui_appbar_hyvsj_geabg_93",
  "appbar-nav": "awsui_appbar-nav_hyvsj_geabg_117",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_geabg_121",
  "appbar-tools": "awsui_appbar-tools_hyvsj_geabg_125",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_geabg_166",
  "has-notifications-content": "awsui_has-notifications-content_hyvsj_geabg_173",
  "has-header": "awsui_has-header_hyvsj_geabg_179",
  "has-dynamic-overlap-height": "awsui_has-dynamic-overlap-height_hyvsj_geabg_179",
  "content-type-wizard": "awsui_content-type-wizard_hyvsj_geabg_180",
  "content-type-cards": "awsui_content-type-cards_hyvsj_geabg_183",
  "content-type-table": "awsui_content-type-table_hyvsj_geabg_184",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_geabg_187",
  "background": "awsui_background_hyvsj_geabg_221",
  "notifications-appbar-header": "awsui_notifications-appbar-header_hyvsj_geabg_224",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_geabg_236",
  "overlap": "awsui_overlap_hyvsj_geabg_242",
  "content": "awsui_content_hyvsj_geabg_180",
  "layout": "awsui_layout_hyvsj_geabg_333",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_geabg_415",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_geabg_442",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_geabg_445",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_geabg_449",
  "has-split-panel": "awsui_has-split-panel_hyvsj_geabg_463",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_geabg_463",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_geabg_475",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_geabg_478",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_geabg_493",
  "container": "awsui_container_hyvsj_geabg_501",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_geabg_527",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_geabg_532",
  "is-tools-open": "awsui_is-tools-open_hyvsj_geabg_535",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_geabg_535",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_geabg_535",
  "content-type-default": "awsui_content-type-default_hyvsj_geabg_555",
  "content-type-form": "awsui_content-type-form_hyvsj_geabg_555",
  "unfocusable": "awsui_unfocusable_hyvsj_geabg_596",
  "navigation-container": "awsui_navigation-container_hyvsj_geabg_604",
  "show-navigation": "awsui_show-navigation_hyvsj_geabg_639",
  "animating": "awsui_animating_hyvsj_geabg_661",
  "showButtons": "awsui_showButtons_hyvsj_geabg_1",
  "navigation": "awsui_navigation_hyvsj_geabg_604",
  "openNavigation": "awsui_openNavigation_hyvsj_geabg_1",
  "animated-content": "awsui_animated-content_hyvsj_geabg_722",
  "hide-navigation": "awsui_hide-navigation_hyvsj_geabg_731",
  "notifications": "awsui_notifications_hyvsj_geabg_224",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_geabg_796",
  "position-bottom": "awsui_position-bottom_hyvsj_geabg_842",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_geabg_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_geabg_871",
  "position-side": "awsui_position-side_hyvsj_geabg_899",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_geabg_1",
  "tools-container": "awsui_tools-container_hyvsj_geabg_936",
  "tools": "awsui_tools_hyvsj_geabg_936",
  "openTools": "awsui_openTools_hyvsj_geabg_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_geabg_1021",
  "hide-tools": "awsui_hide-tools_hyvsj_geabg_1031",
  "show-tools": "awsui_show-tools_hyvsj_geabg_1043",
  "has-tools-form": "awsui_has-tools-form_hyvsj_geabg_1021",
  "trigger": "awsui_trigger_hyvsj_geabg_1100",
  "selected": "awsui_selected_hyvsj_geabg_1139"
};
  